/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import { useState } from 'react';

export const useToggle = (initialValue) => {
  const [enabled, update] = useState(initialValue === true);

  const toggle = () => {
    update((prev) => !prev);
  };
  return [enabled, toggle];
};
